<template>
  <div
    class="anchorMenu"
    ref="anchorMenu"
    v-if="userInfo.status !== '3' || userInfo.status !== '4'"
  >
    <!-- <div class="line" :style="{ left: left + 'px' }"></div> -->

    <div
      class="item active"
      @click="handleAnchorChange('baseInfo')"
      ref="baseInfo"
    >
      基础信息
      <!-- <div class="line" ref="line"></div> -->
    </div>
    <div class="item" @click="handleAnchorChange('eduInfo')" ref="eduInfo">
      学历教育
      <!-- <div class="line" ref="line"></div> -->
    </div>
    <div class="item" @click="handleAnchorChange('noEduInfo')" ref="noEduInfo">
      非学历教育
      <!-- <div class="line" ref="line"></div> -->
    </div>
    <div class="item" @click="handleAnchorChange('postInfo')" ref="postInfo">
      职业经历
      <!-- <div class="line" ref="line"></div> -->
    </div>
    <div
      class="item"
      @click="handleAnchorChange('socialInfo')"
      ref="socialInfo"
    >
      社会活动经历
      <!-- <div class="line" ref="line"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  props: ["left"],
  data() {
    return {
      // total: 999,
      scrollY: 0,
      h1: 0,
      h2: 0,
      h3: 0,
      h4: 0,
      h5: 0,
      userInfo: JSON.stringify(sessionStorage.getItem("userInfo"))
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
    this.setDomHeight();
  },
  methods: {
    handleScroll() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.addZhanwei();
          this.scrollY = window.scrollY;
          // this.calcHeight();
          this.setDomHeight();
          if (this.$refs["baseInfo"]) {
            if (this.scrollY + 200 < this.h2) {
              this.$refs["baseInfo"].className = "item active";
              this.$refs["baseInfo"].setAttribute("class", "item active");
              this.$refs["eduInfo"].className = "item";
              this.$refs["noEduInfo"].className = "item";
              this.$refs["postInfo"].className = "item";
              this.$refs["socialInfo"].className = "item";
            }
            if (this.scrollY + 200 > this.h2) {
              this.$refs["eduInfo"].className = "item active";
              this.$refs["baseInfo"].className = "item";
              this.$refs["noEduInfo"].className = "item";
              this.$refs["postInfo"].className = "item";
              this.$refs["socialInfo"].className = "item";
            }
            if (this.scrollY + 200 > this.h3) {
              this.$refs["noEduInfo"].className = "item active";
              this.$refs["baseInfo"].className = "item";
              this.$refs["eduInfo"].className = "item";
              this.$refs["postInfo"].className = "item";
              this.$refs["socialInfo"].className = "item";
            }
            if (this.scrollY + 200 > this.h4) {
              this.$refs["postInfo"].className = "item active";
              this.$refs["baseInfo"].className = "item";
              this.$refs["eduInfo"].className = "item";
              this.$refs["noEduInfo"].className = "item";
              this.$refs["socialInfo"].className = "item";
            }
            if (this.scrollY + 200 > this.h5) {
              this.$refs["socialInfo"].className = "item active";
              this.$refs["baseInfo"].className = "item";
              this.$refs["eduInfo"].className = "item";
              this.$refs["noEduInfo"].className = "item";
              this.$refs["postInfo"].className = "item";
            }
          }
        }, 100);
      }, 100);
    },
    addZhanwei() {
      if (window.scrollY > 500) {
        if (!document.getElementById("zhanwei")) {
          var el = document.createElement("div");
          el.style.height = "100px";
          el.id = "zhanwei";
          let parent = document.getElementsByClassName("piList")[0];
          // console.log(baseInfo,parent);
          let warning = document.getElementById("warning");
          // console.log(warning);
          let tt=document.getElementById("tipText");
          if (parent) {
            warning.insertBefore(el, tt);
          }
        }

        this.$refs.anchorMenu !== undefined &&
          this.$refs.anchorMenu.setAttribute("class", "anchorMenu fixed");
      } else {
        if (document.getElementById("zhanwei")) {
          document.getElementById("zhanwei").remove();
        }
        this.$refs.anchorMenu !== undefined &&
          this.$refs.anchorMenu.setAttribute("class", "anchorMenu");
      }
    },
    handleAnchorChange(ref) {
      this.$scrollTo("#" + ref, 500, {
        offset: document.getElementsByClassName("fixed")[0] ? -100 : -60
      });
      // Object.keys(this.$refs).forEach(item => {
      //   if (item !== "anchorMenu") this.$refs[item].className = "item";
      // });
      // this.$refs[ref].className = "item active";
    },
    // calcHeight() {
    //   // this.$nextTick(() => {
    //   this.total = document.getElementsByClassName(
    //     "personalServer"
    //   )[0].offsetHeight;
    //   // });
    // },
    setDomHeight() {
      // console.log(document.getElementById("baseInfo").offsetTop);
      this.$nextTick(() => {
        setTimeout(() => {
          this.h1 = document.getElementById("baseInfo").offsetTop;
          this.h2 = document.getElementById("eduInfo").offsetTop;
          this.h3 = document.getElementById("noEduInfo").offsetTop;
          this.h4 = document.getElementById("postInfo").offsetTop;
          this.h5 = document.getElementById("socialInfo").offsetTop;
        }, 0);
      });
    }
  },
  watch: {
    scrollY(newValue, oldValue) {
      this.scrollY = newValue;
    }
  }
};
</script>

<style scoped lang="scss">
.fixed {
  position: fixed !important;
  top: 0;
  width: 846px;
  background: #fff;
  box-sizing: border-box;
  z-index: 1;
}
.anchorMenu {
  border: 1px solid #f1f2f6;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 26px 0 0 0;
  position: relative;
  margin-bottom: 30px;
  z-index: 1;
  .line {
    background: #3b61b2;
    height: 5px;
    width: 62px;
    position: absolute;
    bottom: 0;
    left: 48px;
    // transform: translateX(70px);
    transition: all 0.3s;
  }
  .item {
    position: relative;
    cursor: pointer;
    padding-bottom: 21px;
  }
  .active {
    border-bottom: 5px solid #3b61b2;
    padding-bottom: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Anchor.vue